import gql from 'graphql-tag';

export const GET_TABLE = gql`
  query GetTable($tableId: ID!) {
    table: Table(id: $tableId) {
      id
      code
    }
  }
`;
